import React from 'react';
import PropTypes from 'prop-types';

const Send = ({ fill = 'var(--PRIMARY)' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 0.967509C16.3734 0.88671 16.2264 0.843781 16.0762 0.843781C15.9261 0.843781 15.7791 0.88671 15.6525 0.967509L1.5525 9.10501C1.41902 9.18377 1.31146 9.29982 1.24307 9.4389C1.17468 9.57798 1.14844 9.73402 1.16756 9.88782C1.18669 10.0416 1.25035 10.1865 1.35072 10.3046C1.45109 10.4227 1.58379 10.5088 1.7325 10.5525L6.2325 11.9625L6.375 12L6.9825 16.2675C6.99638 16.4481 7.06068 16.6212 7.16808 16.767C7.27548 16.9129 7.42167 17.0256 7.59 17.0925C7.70342 17.1424 7.82607 17.168 7.95 17.1675C8.09045 17.1731 8.23042 17.1478 8.36001 17.0934C8.48961 17.0389 8.60567 16.9567 8.7 16.8525L11.7 13.59L13.95 14.235C14.0595 14.2659 14.1742 14.2732 14.2867 14.2564C14.3992 14.2396 14.5069 14.1991 14.6025 14.1375C14.6977 14.0794 14.7788 14.0007 14.8398 13.9073C14.9007 13.8139 14.9401 13.7081 14.955 13.5975L16.8375 1.74001C16.8651 1.59225 16.8477 1.4396 16.7876 1.30185C16.7274 1.16411 16.6272 1.04762 16.5 0.967509ZM3.9525 9.54751L12.51 4.59001L6.84 10.5L3.9525 9.54751ZM8.3775 14.835L8.055 12.585L8.385 12.69L9.975 13.14L8.3775 14.835ZM13.5375 12.4725L9.5175 11.34L8.52 11.0175L14.7825 4.50001L13.5375 12.4725Z"
      fill={fill}
    />
  </svg>
);

Send.propTypes = {
  fill: PropTypes.string,
};

export default Send;
